import { Injectable } from '@angular/core';
import { UserService } from "../services/user.service";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

/*
    Fields to save user details into database
 */
export interface SearchService {
    date?: String;
    search?: String
}

@Injectable()
export class TransactionService {

    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router, private userService: UserService) { }

    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }

    /*
        api call for get Withdraw Batchs list
    */
    getWithdrawBatchs(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-withdraw-batchs', filter, configs)
    }
    getClientTransaction(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-client-transactions', filter, configs)
    }
    getClientINRBatches(id: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.get<any>(this.api_url + `get-client-inr-batches/${id}`, configs)
    }
    addClientTransaction(payload: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'add-client-transaction', payload, configs)
    }
    saveSentReceiveINR(payload: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'sent-receive-inr', payload, configs)
    }
    addINRDeposit(payload: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'add-inr-deposit', payload, configs)
    }
    transactionReport(payload: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-transaction-report', payload, configs)
    }
    inrTransactionReport() {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.get<any>(this.api_url + 'get-inr-transaction-report', configs)
    }
    clientTransactionReport(payload: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'client-transaction-report', payload, configs)
    }

}



// WEBPACK FOOTER //
// ./src/app/services/transaction.service.ts